import {yupResolver} from '@hookform/resolvers/yup';
import moment from 'moment';
import {ReactNode, useEffect, useState} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {
  SafeAreaView,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import QRCode from 'react-native-qrcode-svg';
import Icon from '@react-native-vector-icons/fontawesome';
import {useSelector} from 'react-redux';
import * as yup from 'yup';
import {ShowToast, generateUpiLink, retrieveSetting} from '../Common/common';
import {TextInput} from '../Components/BTTextInput';
import {useGetACMCompanysQuery} from '../redux/services/acmcompanyApi';
import {useGetModesQuery} from '../redux/services/amodeApi';
import {useGetFOEOccRoomsQuery} from '../redux/services/foecheckinApi';
import {useGetPOAOutletsQuery} from '../redux/services/poaoutletApi';
import {useGetPOEBillsQuery} from '../redux/services/poebillApi';
import {
  useGetPOEBillSettleByIdQuery,
  useInsertPOEBillSettleMutation,
  useUpdatePOEBillSettleMutation,
} from '../redux/services/poebillsettleApi';
import {RootState} from '../redux/store';
import styles from '../styles/Styles';
import React from 'react';

import T from '../Components/T';
import { tp } from '../utils/translateText';
interface ColProps {
  children: ReactNode;
}

interface RowProps {
  children: ReactNode;
}

const Col: React.FC<ColProps> = ({children}) => {
  return <View style={styles.col}>{children}</View>;
};

const Row: React.FC<RowProps> = ({children}) => {
  return <View style={styles.row}>{children}</View>;
};

const POSSettlement = ({navigation, route}: UniversalProps) => {
  const gdata = useSelector((state: RootState) => state.gdata);
  const cid = gdata.company;
  const {data: outletData} = useGetPOAOutletsQuery(gdata.company);
  const [qr, setQR] = useState(0);
  const [upiid, setUpiid] = useState('');
  const [payeename, setPayeename] = useState('');
  const [defOutlet, setDefOutlet] = useState(13);

  useEffect(() => {
    const retDefOutlet = async () => {
      setDefOutlet(Number(await retrieveSetting('defoutlet')));
    };

    retDefOutlet();
  }, []);

  const outlets = outletData?.map((value, i) => {
    return {
      label: value.ol_sname,
      id: value.ol_id,
      value: value,
    };
  });

  useEffect(() => {
    const temp: any = outlets;
    if (temp?.length > 0) {
      setQR(temp[0].value.ol_qr ?? '');
      setUpiid(temp[0].value.ol_upiid ?? '');
      setPayeename(temp[0].value.ol_payeename ?? '');
    }
  }, [outlets]);

  const [defArea, setDefArea] = useState('');

  useEffect(() => {
    const retDefArea = async () => {
      setDefArea(await retrieveSetting('defarea'));
    };

    retDefArea();
  }, []);

  const [bid, setBid] = useState(0);

  const {data, isLoading, refetch} = useGetPOEBillsQuery(
    {
      cid: cid,
      bid: route.bid,
    },
    {refetchOnFocus: true},
  );

  const {data: settleData} = useGetPOEBillSettleByIdQuery(bid.toString());
  const {data: companyData} = useGetACMCompanysQuery(cid);
  const {data: occroomData} = useGetFOEOccRoomsQuery({cid: cid, coid: 0});
  const {data: modeData} = useGetModesQuery(cid);

  useEffect(() => {
    if (!data) {
      return;
    }

    setBid(
      Number(data.find(e => Number(e.bl_id) === Number(route.bid))?.bl_id),
    );
  }, [data]);

  const modes: any = modeData?.map((value, key) => {
    return {
      label: value.md_name,
      id: value.md_id,
      value: value,
    };
  });

  const rooms: any = occroomData
    ? occroomData?.map((value: any, key: any) => {
        return {
          label: value.rm_name,
          id: value.cd_room,
          value: value,
        };
      })
    : [];

  const companys = companyData?.map(value => {
    return {
      label: value.cp_name,
      id: value.cp_id,
      value: value,
    };
  });

  let initialValues: any = {
    bs_id: 0,
    bs_bill: 0,
    bs_date:
      moment(gdata.today).format('YYYY/MM/DD') + moment().format(' HH:mm:ss'),
    bs_amt: 0,
    bs_disc: 0,
    bs_tips: 0,
    bs_total: 0,
    bs_flg: 0,
    bs_uid: gdata.user,
    bs_cdt: moment().format('YYYY/MM/DD HH:mm:ss'),
    bs_muid: gdata.user,
    bs_mdt: moment().format('YYYY/MM/DD HH:mm:ss'),
    bs_details: [],
  };

  const validationSchema = yup.object({
    bs_bill: yup.number().moreThan(0, 'Bill No is required'),
    bs_amt: yup.number().typeError('Bill Amount is required'),
    // Was previously `.oneOf([yup.ref('bs_amt'), undefined])`, which required
    // an exact match and would have silently blocked submission entirely
    // once partial cash payments started actually reaching bs_total (see the
    // Received Amount fix above) - a partial payment must be <= the bill
    // amount, not necessarily equal to it.
    bs_total: yup
      .number()
      .typeError('Received Amount is required')
      .max(yup.ref('bs_amt'), 'Received Amount cannot exceed Bill Amount'),
  });

  const {...methods} = useForm<any>({
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
  });

  const [isSaving, setIsSaving] = useState(false);
  const [insertPOEBillSettle] = useInsertPOEBillSettleMutation();
  const [updatePOEBillSettle] = useUpdatePOEBillSettleMutation();

  const onSubmit = async (values: any) => {
    if (isSaving) return;
    setIsSaving(true);

    // bs_details[0].sd_refno was previously hardcoded to '' when a payment
    // mode icon was tapped and never synced afterward - the cashier's actual
    // Ref No. entry (bs_refno, shown for card/UPI modes) never reached the
    // persisted settlement row. Sync it here at submit time.
    const payload = {
      ...values,
      bs_details: (values.bs_details || []).map((d: any, i: number) =>
        i === 0 ? {...d, sd_refno: values.bs_refno || d.sd_refno || ''} : d,
      ),
    };

    try {
      if (values.bs_id) {
        await updatePOEBillSettle(payload).unwrap();
        ShowToast('Data Updated Sucessfully');
      } else {
        await insertPOEBillSettle(payload).unwrap();
        ShowToast('Data Saved Sucessfully');
      }
      methods.reset(initialValues);
      refetch();
    } catch (error: any) {
      ShowToast(error?.data?.message || error?.message || 'Error saving settlement', 'error');
    }
    setIsSaving(false);
  };

  const [viewQR, setViewQR] = useState('');
  const [view, setView] = useState(0);
  const [tips, setTips] = useState(0);
  const [mode, setMode] = useState(0);
  const [modeTyp, setModeTyp] = useState(0);
  const [balAmt, setBalAmt] = useState(0);

  const PrintReport = async (dat: any) => {
    // No print template exists for the pending-bill list yet - this was a
    // silent no-op stub that misled staff into thinking the print icon
    // worked. Surface that plainly instead until real printing is built.
    ShowToast('Print is not available yet', 'info');
    return true;
  };

  const renderTables = data
    ?.filter(v => v.tb_areaname == defArea)
    ?.map((value: any, key: any) => {
      const qrLink = generateUpiLink(
        upiid,
        payeename,
        Number(value.bl_amt) + tips,
        'Amount Paid for Food',
      );
      return (
        <View style={styles.item}>
          <Row>
            <Col>
              <Text style={styles.descr}>{value.bl_no}</Text>
              <Text style={styles.descr}>
                {moment(value.bl_date).format('DD-MM HH:mm')}
              </Text>
            </Col>
            <Col>
              <Text style={styles.descr}>{value.tb_name}</Text>
              <Text style={styles.descr}>{value.em_name}</Text>
            </Col>
            <Col>
              <Text style={styles.amt}>{'Rs.' + value.bl_amt}</Text>
            </Col>
            <Col>
              <TouchableOpacity
                onPress={() => {
                  setViewQR(prev => (prev == value.bl_no ? '' : value.bl_no));
                  setTips(0);
                  methods.setValue('bs_tips', 0);
                }}>
                <Icon
                  name="qrcode"
                  size={35}
                  color="#900C3F"
                  style={styles.icon}
                />
              </TouchableOpacity>
            </Col>
          </Row>
          {viewQR == value.bl_no ? (
            <>
              <Row>
                <Col>
                  <Text style={styles.descr}><T>Tips</T></Text>
                </Col>
                <Col>
                  <TouchableOpacity
                    onPress={() => {
                      const newTips = tips >= 5 ? tips - 5 : 0;
                      setTips(newTips);
                      methods.setValue('bs_tips', newTips);
                    }}
                    disabled={tips == 0}>
                    <Icon
                      name="minus"
                      size={35}
                      color="#19A7CE"
                      style={styles.icon}
                    />
                  </TouchableOpacity>
                </Col>
                <Col>
                  <TouchableOpacity
                    onPress={() => {
                      const newTips = tips == 0 ? 10 : tips + 5;
                      setTips(newTips);
                      methods.setValue('bs_tips', newTips);
                    }}>
                    <Icon
                      name="plus"
                      size={35}
                      color="#19A7CE"
                      style={styles.icon}
                    />
                  </TouchableOpacity>
                </Col>
                <Col>
                  <FormProvider {...methods}>
                    <TextInput
                      name="bs_tips"
                      label=""
                      placeholder={tp("Tips")}
                      keyboardType="numeric"
                      textAlign="right"
                      onChangeText={txt => setTips(Number(txt))}
                    />
                  </FormProvider>
                </Col>
              </Row>
              <Row>
                <Col>
                  <SafeAreaView style={{flex: 1}}>
                    <QRCode value={qrLink} />
                    <Text style={styles.amt1}>
                      <T>Rs.</T>{(Number(value.bl_amt) + tips).toFixed(2)}
                    </Text>
                  </SafeAreaView>
                </Col>
              </Row>
            </>
          ) : null}
          <Row>
            <Col>
              <TouchableOpacity onPress={() => PrintReport(value)}>
                <Icon name="print" size={35} color="#2196F3" />
              </TouchableOpacity>
            </Col>
            <Col>
              <TouchableOpacity
                onPress={() => {
                  const md = modeData?.find(
                    (v: any) => v.md_flag == '1',
                  )?.md_id;
                  setModeTyp(1);
                  setMode(Number(md));
                  setView(value.bl_id);

                  methods.setValue('bs_bill', value.bl_id);
                  methods.setValue('bs_amt', value.bl_amt);
                  methods.setValue('bs_total', value.bl_amt);
                  methods.setValue('bs_details', [
                    {
                      sd_id: 0,
                      sd_srid: 1,
                      sd_mode: md,
                      sd_refno: '',
                      sd_refdt: '1/1/1',
                      sd_refbank: '',
                      sd_amt: value.bl_amt,
                      sd_company: 0,
                      sd_room: 0,
                    },
                  ]);
                  methods.setValue('bs_amt1', 0);
                  setBalAmt(value.bl_amt);
                }}>
                <Icon
                  name="inr"
                  size={35}
                  color={
                    modeTyp == 1 && value.bl_id == view ? '#F7B352' : '#19A7CE'
                  }
                  style={styles.icon}
                />
              </TouchableOpacity>
            </Col>
            <Col>
              <TouchableOpacity
                onPress={() => {
                  const md = modeData?.find(
                    (v: any) => v.md_flag == '2',
                  )?.md_id;
                  setModeTyp(2);
                  setMode(Number(md));
                  setView(value.bl_id);

                  methods.setValue('bs_bill', value.bl_id);
                  methods.setValue('bs_amt', value.bl_amt);
                  methods.setValue('bs_total', value.bl_amt);
                  methods.setValue('bs_details', [
                    {
                      sd_id: 0,
                      sd_srid: 1,
                      sd_mode: md,
                      sd_refno: '',
                      sd_refdt: '1/1/1',
                      sd_refbank: '',
                      sd_amt: value.bl_amt,
                      sd_company: 0,
                      sd_room: 0,
                    },
                  ]);
                  methods.setValue('bs_amt1', 0);
                  setBalAmt(value.bl_amt);
                }}>
                <Icon
                  name="credit-card-alt"
                  size={35}
                  color={
                    modeTyp == 2 && value.bl_id == view ? '#F7B352' : '#19A7CE'
                  }
                  style={styles.icon}
                />
              </TouchableOpacity>
            </Col>
            <Col>
              <TouchableOpacity
                onPress={() => {
                  const md = modeData?.find(
                    (v: any) => v.md_flag == '5',
                  )?.md_id;
                  setModeTyp(3);
                  setMode(Number(md));
                  setView(value.bl_id);

                  methods.setValue('bs_bill', value.bl_id);
                  methods.setValue('bs_amt', value.bl_amt);
                  methods.setValue('bs_total', value.bl_amt);
                  methods.setValue('bs_details', [
                    {
                      sd_id: 0,
                      sd_srid: 1,
                      sd_mode: md,
                      sd_refno: '',
                      sd_refdt: '1/1/1',
                      sd_refbank: '',
                      sd_amt: value.bl_amt,
                      sd_company: 0,
                      sd_room: 0,
                    },
                  ]);
                  methods.setValue('bs_amt1', 0);
                  setBalAmt(value.bl_amt);
                }}>
                <Icon
                  name="qrcode"
                  size={35}
                  color={
                    modeTyp == 3 && value.bl_id == view ? '#F7B352' : '#19A7CE'
                  }
                  style={styles.icon}
                />
              </TouchableOpacity>
            </Col>
          </Row>
          {value.bl_id == view ? (
            <FormProvider {...methods}>
              {modeTyp == 1 ? (
                <>
                  <Row>
                    <Col>
                      <Text style={styles.descr}><T>Received Amount</T></Text>
                    </Col>
                    <Col>
                      <TextInput
                        name="bs_amt1"
                        label=""
                        placeholder={tp("Received Amount")}
                        keyboardType="numeric"
                        textAlign="right"
                        onChangeText={txt => {
                          // Previously only balAmt (a local display value) was
                          // updated here - bs_total/bs_details[0].sd_amt stayed
                          // pinned to the full bill amount set when the payment
                          // mode icon was tapped, so a partial cash payment was
                          // still persisted as a full settlement. Update the
                          // actual submitted amount too.
                          const received = Number(txt) || 0;
                          setBalAmt(Number(value.bl_amt) - received);
                          methods.setValue('bs_total', received);
                          methods.setValue('bs_details.0.sd_amt', received);
                        }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Text style={styles.descr}><T>Balance Amount</T></Text>
                    </Col>
                    <Col>
                      <Text style={styles.amt}>{balAmt}</Text>
                    </Col>
                  </Row>
                </>
              ) : (
                <Row>
                  <Col>
                    <Text style={styles.descr}><T>Ref No.</T></Text>
                  </Col>
                  <Col>
                    <TextInput
                      name="bs_refno"
                      label=""
                      placeholder={tp("Reference No")}
                    />
                  </Col>
                </Row>
              )}
              <Row>
                <Col>
                  <TouchableOpacity
                    disabled={isSaving}
                    onPress={methods.handleSubmit(onSubmit, errors => {
                      const firstError = Object.values(errors)[0] as any;
                      ShowToast(
                        firstError?.message || 'Please check the entered details',
                        'error',
                      );
                    })}>
                    <Icon
                      name="save"
                      size={35}
                      color="#6CDA85"
                      style={styles.icon}
                    />
                  </TouchableOpacity>
                </Col>
              </Row>
            </FormProvider>
          ) : null}
        </View>
      );
    });

  return (
    <View style={styles.app}>
      {/* Modern Header */}
      <View style={styles.modernHeaderContainer}>
        <Text style={styles.modernHeaderTitle}><T>Pending Bills</T></Text>
      </View>

      <ScrollView
        keyboardShouldPersistTaps="handled"
        contentContainerStyle={{
          flexGrow: 1,
          paddingBottom: 80,
        }}>
        {renderTables}
      </ScrollView>
    </View>
  );
};

export default POSSettlement;

